export default "__VITE_ASSET__5SOHylZB__"